import { Pipe, PipeTransform } from '@angular/core'
import * as Moment from 'moment';
/* 
Transform the broadcast date of a mix to the format
Broadcast 'x months/days/years ago'
*/

@Pipe({name: 'dateFormatter'})
export class DateFormatterPipe implements PipeTransform {
  transform(value: string): string {
    let formatted_time =  Moment(value, "YYYY-MM-DD").fromNow();
    return formatted_time;
  } 
}


// WEBPACK FOOTER //
// /Users/martyndavies/code/algolia/essentialvault-angular/src/app/helpers/dateformatter.pipe.ts